import { forwardRef, HTMLProps } from 'react'
import clsx from 'clsx'

type InputProps = HTMLProps<HTMLInputElement>

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...rest }, ref) => (
    <input
      className={clsx(
        'rounded w-full px-4 py-2 outline-none text-sm text-gray-800 shadow-md',
        className
      )}
      type="text"
      ref={ref}
      {...rest}
    />
  )
)

export default Input
